module.exports = __webpack_public_path__ + "img/quality1.7c9260a3.png";